// MAREIA countdown badge — ticks down to a target ISO date set via section block settings.
(function () {
  function setupCountdown(el) {
    const targetIso = el.dataset.target;
    const availableLabel = el.dataset.availableLabel || 'Available now';
    if (!targetIso) return;

    const target = new Date(targetIso).getTime();
    if (Number.isNaN(target)) return;

    const pad = (n) => String(n).padStart(2, '0');

    function render() {
      const diff = target - Date.now();
      if (diff <= 0) {
        el.textContent = availableLabel;
        clearInterval(timer);
        return;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      el.textContent = `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    }

    render();
    const timer = setInterval(render, 1000);
  }

  document.querySelectorAll('[data-mareia-countdown]').forEach(setupCountdown);
})();
